import React, {Component} from 'react';
import axios from "axios";

import classes from './PatternConditionsInput.module.css';
import apiUrl from "../../../shared/config";
import NewPatternCondition from "../NewPatternCondition/NewPatternCondition";
import PatternConditionInput from "../../UI/PatternConditionInput/PatternConditionInput";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

class PatternConditionsInput extends Component  {
    state = {
        pattern_conditions: [],
        selected_pattern_conditions: [],
        new_pattern_condition: false
    };

    componentDidMount() {
        if (this.state.pattern_conditions !== []) {
            axios.get(apiUrl +'PatternConditions/getPatternConditions')
                .then(response => {
                    this.setState({pattern_conditions: response.data});
                });
        }
        this.setState({selected_pattern_conditions: this.props.patternConditions});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.patternConditions !== this.props.patternConditions) {
            this.setState({selected_pattern_conditions: this.props.patternConditions})
        }
    }

    newPatternConditionToggle = () => {
        this.setState({new_pattern_condition: !this.state.new_pattern_condition});
    };

    newPatternConditionsHandler = (new_pattern_condition_add) => {
        this.props.patternConditionsUpdate(
            [...this.state.selected_pattern_conditions, new_pattern_condition_add].map((condition) => {
                return {value: condition.condition_id, label: condition.condition_title, description: condition.condition_description}
            })
        );
        this.setState({
            pattern_conditions: [...this.state.pattern_conditions, new_pattern_condition_add],
        });
    };

    render() {

        let pattern_conditions_input_element= (
            <React.Fragment>
                <dd className="col-sm-9">
                    <PatternConditionInput
                        pattern_conditions={this.state.pattern_conditions}
                        pattern_condition_filter={this.state.selected_pattern_conditions.map(condition => condition.condition_id)}
                        patternConditionsUpdate={this.props.patternConditionsUpdate}
                        updatePage={this.props.updatePage}
                        closePatternDetails={this.props.closePatternDetails}
                    />
                </dd>
                <dt className="col-sm-3"></dt>
            </React.Fragment>
        )

        let new_pattern_condition_jsx = '';
        if (this.state.new_pattern_condition === true) {
            new_pattern_condition_jsx = (<NewPatternCondition
                pattern_conditions={this.state.pattern_conditions}
                newPatternConditionToggle={this.newPatternConditionToggle}
                onNewPatternCondition={this.newPatternConditionsHandler}
                token={this.props.token}
                userId={this.props.userId}
            />);
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Conditions</label></dt>
                {pattern_conditions_input_element}
                {new_pattern_condition_jsx}
                {!this.state.new_pattern_condition ? <dd className="col-sm-9" style={{display: "inline-flex", justifyContent: "right"}}>
                    <span>
                        Enter New Condition: <AddCircleOutlineIcon
                                onClick={this.newPatternConditionToggle}
                                className={classes.AddButton}
                            />
                    </span>
                </dd> : ''}
            </dl>
        );
    }
}

export default PatternConditionsInput;